
import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import mixpanel from "mixpanel-browser";


import App from "./App";
import "./index.css";
import "./utils/i18n";
import initMixpanel from "./utils/mixpanel"
import {ThemeProvider} from "../src/pages/contexts/ThemeContext";



const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();


// ✅ Initialize Mixpanel with ad-blocker bypass (no Django conflicts)
console.log("🚀 Initializing Mixpanel with ad-blocker bypass...")
initMixpanel()
// Suppress ResizeObserver loop — harmless browser warning
window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation()
    }
})

const origError = window.onerror
window.onerror = (message, ...args) => {
    if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
        return true
    }
    return origError?.apply(window, [message, ...args])
}
// Suppress ResizeObserver loop error from React dev overlay
const observer = new MutationObserver(() => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay')
    if (overlay) overlay.remove()
})
observer.observe(document.body, { childList: true, subtree: true })
root.render(
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <Routes>
                    <Route path="/*" element={<App/>}/>
                </Routes>
            </ThemeProvider>
        </QueryClientProvider>

    </BrowserRouter>
);
